export default function initResults() {
  Alpine.data('results', () => ({
    selectedTab: ((new Date()).getFullYear()).toString(),
    showMoreTabs: false,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,

    init() {
      const activeTabBtn: HTMLElement|null = this.$el.querySelector('button.active');
      if (activeTabBtn && activeTabBtn.dataset.tab) {
        this.selectedTab = activeTabBtn.dataset.tab;
      }

      this.$watch('selectedTab', () => {
        const btns = this.$root.getElementsByTagName('button');
        Array.from(btns).forEach((btn) => {
          const btnTab = btn.dataset.tab;
          if (btnTab) {
            const isSelected = this.selectedTab === btnTab;
            btn.classList.toggle('active', isSelected);
            btn.ariaSelected = isSelected ? 'true' : 'false';
            btn.tabIndex = isSelected ? 0 : -1;
          } else {
            btn.classList.remove('active');
          }
        });

        const results = this.$root.getElementsByClassName('results');
        Array.from(results).forEach((result) => {
          if (result instanceof HTMLElement && result.dataset) {
            const resultTab = result.dataset.tab;
            if (resultTab && this.selectedTab === resultTab) {
              result.classList.remove('hidden');
              result.hidden = false;
              result.ariaHidden = 'false';
            } else {
              result.classList.add('hidden');
              result.hidden = true;
              result.ariaHidden = 'true';
            }
          }
        });

        this.showMoreTabs = false;
      });

      this.$watch('showMoreTabs', () => {
        const btnTabGroup: HTMLElement|null = this.$root.querySelector('[class*="group/btn-tabs"]');
        btnTabGroup?.classList.toggle('active');
        const btn = btnTabGroup?.querySelector('button');
        if (btn) {
          btn.ariaExpanded = this.showMoreTabs ? 'true' : 'false';
        }
      })

      const results = this.$root.querySelector('.results-nav') as HTMLElement|null;
      if (results) {
        results.addEventListener('mousedown', (e) => {
          this.isDragging = true;
          this.startX = e.pageX - results.offsetLeft;
          this.scrollLeft = results.scrollLeft;
        });

        results.addEventListener('mouseleave', () => {
          this.isDragging = false;
        });

        results.addEventListener('mouseup', () => {
          this.isDragging = false;
        });

        results.addEventListener('mousemove', (e) => {
          if (!this.isDragging) return;
          e.preventDefault();
          const x = e.pageX - results.offsetLeft;
          const walk = x - this.startX;
          results.scrollLeft = this.scrollLeft - walk;
        });

        results.addEventListener('touchstart', (e) => {
          this.isDragging = true;
          this.startX = e.touches[0].pageX - results.offsetLeft;
          this.scrollLeft = results.scrollLeft;
        });

        results.addEventListener('touchend', () => {
          this.isDragging = false;
        });

        results.addEventListener('touchmove', (e) => {
          if (!this.isDragging) return;
          e.preventDefault();
          const x = e.touches[0].pageX - results.offsetLeft;
          const walk = x - this.startX;
          results.scrollLeft = this.scrollLeft - walk;
        });
      }
    },

    selectTab() {
      if (this.$el.dataset.tab) {
        this.selectedTab = this.$el.dataset.tab;
      }
    },

    onTabKeydown(event: KeyboardEvent) {
      const tabButtons = Array.from(this.$root.querySelectorAll<HTMLButtonElement>('button[data-tab]'));
      const currentIndex = tabButtons.findIndex((btn) => btn.dataset.tab === this.selectedTab);
      if (currentIndex < 0) {
        return;
      }

      let targetIndex: number|null = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          targetIndex = (currentIndex + 1) % tabButtons.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          targetIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
          break;
        case 'Home':
          targetIndex = 0;
          break;
        case 'End':
          targetIndex = tabButtons.length - 1;
          break;
      }

      if (targetIndex === null) {
        return;
      }

      event.preventDefault();
      const targetBtn = tabButtons[targetIndex];
      if (targetBtn.dataset.tab) {
        this.selectedTab = targetBtn.dataset.tab;
        targetBtn.focus();
      }
    },


    toggleMoreTabs() {
      this.showMoreTabs = !this.showMoreTabs;
    },
  }))
}